const contacts = {
  items: [
    {
      title: 'Зв’язатися з нами:',
      href: 'tel:+380986146177',
      description: '+380 (98) 614 61 77',
    },
    {
      title: 'Електронна пошта:',
      href: 'mailto:p.info@pegasusarms.com.ua',
      description: 'p.info@pegasusarms.com.ua',
    },
    {
      title: 'Долучайтеся до  команди:',
      href: 'mailto:hr@pegasusarms.com.ua',
      hrefTel: 'tel:+380754445583',
      description: 'hr@pegasusarms.com.ua',
      descriptionTel: '+380 (75) 444 55 83',
    },
  ],
}

export default contacts
